import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/forms/bases/FormInput'
import FormLabel from 'components/labels/FormLabel'

const FormTextInput = ({ label, ...otherProps }) => (
  <div>
    <FormLabel>{label}</FormLabel>
    <FormInput
      {...otherProps}
    />
  </div>
)

FormTextInput.propTypes = {
  label: PropTypes.string.isRequired,
}
FormTextInput.defaultProps = {
}

export default FormTextInput



// WEBPACK FOOTER //
// ./src/components/forms/FormTextInput.js